import React from "react";
import Masonry from "react-masonry-css";
import { Card } from "antd";
import { motion } from "framer-motion";

export default function PictureGrid({ images }) {
  const breakpoints = {
    default: 4,
    1200: 3,
    768: 2,
    480: 1,
  };

  return (
    <div style={{ padding: "20px" }}>
      <Masonry
        breakpointCols={breakpoints}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {images.map((src, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.85, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ delay: i * 0.05, type: "spring", stiffness: 120 }}
          >
            <Card
              hoverable
              style={{
                borderRadius: "16px",
                overflow: "hidden",
                marginBottom: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
              }}
              bodyStyle={{ padding: 0 }}
            >
              {/* Square container */}
              <div
                style={{
                  width: "100%",
                  paddingTop: "100%", // makes the square
                  position: "relative",
                }}
              >
                <img
                  src={"images/gallery/" + src}
                  alt="gallery"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.4s ease",
                  }}
                  className="grid-img"
                />
              </div>
            </Card>
          </motion.div>
        ))}
      </Masonry>
    </div>
  );
}
